import request from '@/utils/request'

// 查询H5页面列表
export function listH5Pages(query) {
  return request({
    url: '/system/h5Pages/list',
    method: 'get',
    params: query
  })
}

// 查询H5页面详细
export function getH5Pages(pageId) {
  return request({
    url: '/system/h5Pages/' + pageId,
    method: 'get'
  })
}

// 新增H5页面
export function addH5Pages(data) {
  return request({
    url: '/system/h5Pages',
    method: 'post',
    data: data
  })
}

// 修改H5页面
export function updateH5Pages(data) {
  return request({
    url: '/system/h5Pages',
    method: 'put',
    data: data
  })
}

// 删除H5页面
export function delH5Pages(pageId) {
  return request({
    url: '/system/h5Pages/' + pageId,
    method: 'delete'
  })
}

// 导出H5页面
export function exportH5Pages(query) {
  return request({
    url: '/system/h5Pages/export',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/h5Pages.js